import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { AddItemPage } from '../add-item/add-item'
import swal from 'sweetalert';

@Component({
  selector: 'email-template',
  templateUrl: 'email-template.html',
})
export class EmailTemplatePage {
  bulletitems= new Array;
  bulletitems1= new Array;
  searchQuery: string = '';
  items;
  zones = new Array;
  httpRunning = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    public config: ConfigProvider,
    public viewCtrl: ViewController,
    public modalCtrl: ModalController,
    public loading: LoadingProvider,
    public shared: SharedDataProvider, ) {


    console.log("CUstomer ID:",this.shared.customerData.customers_id)
    var data = { ar_id: this.shared.customerData.customers_id };
      this.loading.show();
    http.post(this.config.url + 'getBullets', data).map(res => res.json()).subscribe(data => {
        this.loading.hide();
      if (data.success == 1) {
        console.log("Bullets:",data.data);
        this.bulletitems = data.data;
      }

    });
  }

  editItem(item){
    let index: number = this.bulletitems.indexOf(item);
    let editModal = this.modalCtrl.create(AddItemPage, {item:item,index:index});

    console.log("Edit Item:",item);
    editModal.onDidDismiss((item) => {

          if(item){
            item.ar_id = this.shared.customerData.customers_id;

             this.bulletitems.splice(item.index, 1,item);
             console.log("Save Item:",item);
            //this.saveItem(item);
          }

    });

    editModal.present();

  }

  addItem(){

    let addModal = this.modalCtrl.create(AddItemPage);

    addModal.onDidDismiss((item) => {

          if(item){
            item.ar_id = this.shared.customerData.customers_id;
            console.log("Save Item:",item);
            this.saveItem(item);
          }

    });

    addModal.present();

  }

  saveItem(item){

    this.bulletitems.push(item);
  }

  reorderItems(indexes){
 let element = this.bulletitems[indexes.from];
 this.bulletitems.splice(indexes.from, 1);
 this.bulletitems.splice(indexes.to, 0, element);
};

ionViewWillLeave(){
  this.saveChangesDB();
}
saveChangesDB(){

  var index = 0;
  this.loading.show();
  this.bulletitems.forEach((value, index) => {
    console.log("Update:",value);
    if(value.template_id != null){
    value.priority = index;
    this.http.post(this.config.url + 'updateBullet', value).map(res => res.json()).subscribe(data => {

      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {

        //this.getSubAccounts();
      }

    },
      function (response) {

        this.alert.show("Server Error while updating template. Try again later");
        //console.log(response);
      });

  }
  else{
    value.priority = index;
    value.ar_id = this.shared.customerData.customers_id;
    console.log("Add new item:",value);
    this.http.post(this.config.url + 'insertBullet', value).map(res => res.json()).subscribe(data => {

      this.httpRunning = false;
      //$rootScope.address=response.data.data;
      if (data.success == 1) {

        //this.getSubAccounts();
      }

    },
      function (response) {

        this.alert.show("Server Error while updating template. Try again later");
        //console.log(response);
      });
  }
  });
  this.loading.hide();
}

deleteTask(item,slidingItem){
  console.log("Delete item:",item);



  swal({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  buttons: {
     cancel: true,
     confirm: true,
   },
}).then((value) => {
  console.log("result:",value);
  switch (value) {

    case true:
      console.log("Delete item");
      let index: number = this.bulletitems.indexOf(item);
        if(index > -1){
        this.bulletitems.splice(index, 1);

        var data = { template_id: item.template_id };
          this.loading.show();
        this.http.post(this.config.url + 'deleteBullet', data).map(res => res.json()).subscribe(data => {
            this.loading.hide();
          if (data.success == 1) {

          }

        });
        }
      break;

    default:
      console.log("Here");
      slidingItem.close();
      break;
  }
});






}
  //close modal
  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/email-template/email-template.ts